import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Row, Col, Alert, Card, CardBody, Container, FormFeedback, Input, Label, Form } from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";

import { Link } from "react-router-dom";
import api from "../../api";   // Round 17: public help-info
import withRouter from "../../Components/Common/withRouter";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

// action
import { userForgetPassword } from "../../slices/thunks";

// import images
// import profile from "../../assets/images/bg.png";
import logoLight from "../../assets/images/logofinal.png";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";

const ForgetPasswordPage = props => {
  // Round 17: how employees without e-mail reach IT (Support:ItHelpText, public).
  const [itHelpText, setItHelpText] = useState("");
  useEffect(() => {
    let alive = true;
    api.get("Auth/help-info").then((r) => { if (alive && r?.data?.itHelpText) setItHelpText(r.data.itHelpText); }).catch(() => {});
    return () => { alive = false; };
  }, []);
  const dispatch = useDispatch();

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      emailOrEmpId: '',
    },
    validationSchema: Yup.object({
      emailOrEmpId: Yup.string().trim().required("Please enter your Email or Emp ID"),
    }),
    onSubmit: (values) => {
      dispatch(userForgetPassword(values, props.history));
    }
  });

  const { forgetError, forgetSuccessMsg } = useSelector(state => ({
    forgetError: state.ForgetPassword.forgetError,
    forgetSuccessMsg: state.ForgetPassword.forgetSuccessMsg,
  }));

  document.title = "Reset Password | SSW Technologies";
  return (
    <ParticlesAuth>
      <div className="auth-page-content">

        <Container>
          <Row>
            <Col lg={12}>
              <div className="text-center mt-sm-5 mb-4 text-white-50">
                <div>
                  <Link to="/" className="d-inline-block auth-logo">
                    <img src={logoLight} alt="" height="120" />
                  </Link>
                </div>
                <p className="mt-3 fs-15 fw-medium" style={{ fontSize: "25px", color: "#070161" }}>SS White Technologies Inc.</p>
              </div>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="mt-4">

                <CardBody className="p-4">
                  <div className="text-center mt-2">
                    <h5 className="text-primary" style={{ color: "#070161" }}>Reset Password?</h5>
                    {/* <p className="text-muted">Reset password with velzon</p> */}

                    <lord-icon
                      src="https://cdn.lordicon.com/rhvddzym.json"
                      trigger="loop"
                      colors="primary:#0ab39c"
                      className="avatar-xl"
                      style={{ width: "120px", height: "120px" }}
                    >
                    </lord-icon>

                  </div>

                  <Alert className="alert-borderless alert-warning text-center mb-2 mx-2" role="alert">
                    Enter your Email or Emp ID. If an eligible account matches, reset instructions will be sent to the e-mail address on file.
                  </Alert>
                  {/* Round 17: employees without e-mail cannot receive the message */}
                  <Alert className="alert-borderless alert-info text-center mb-2 mx-2" role="alert" style={{ fontSize: 13 }}>
                    <strong>No e-mail address on file?</strong> Nothing can be sent to you.
                    {" "}{itHelpText ? itHelpText : "Contact the IT team"} — they will give you a setup code to use on the
                    {" "}<Link to="/setup-code" className="fw-semibold text-decoration-underline">setup code page</Link>.
                  </Alert>
                  <div className="p-2">
                    {forgetError && forgetError ? (
                      <Alert color="danger" style={{ marginTop: "13px" }}>
                        {forgetError}
                      </Alert>
                    ) : null}
                    {forgetSuccessMsg ? (
                      <Alert color="success" style={{ marginTop: "13px" }}>
                        {forgetSuccessMsg}
                      </Alert>
                    ) : null}
                    <Form
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      <div className="mb-4">
                        <Label className="form-label">Email or Emp ID</Label>
                        <Input
                          name="emailOrEmpId"
                          className="form-control"
                          placeholder="Enter Email or Emp ID"
                          type="text"
                          autoComplete="username"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.emailOrEmpId || ""}
                          invalid={
                            validation.touched.emailOrEmpId && validation.errors.emailOrEmpId ? true : false
                          }
                        />
                        {validation.touched.emailOrEmpId && validation.errors.emailOrEmpId ? (
                          <FormFeedback type="invalid"><div>{validation.errors.emailOrEmpId}</div></FormFeedback>
                        ) : null}
                      </div>

                      <div className="text-center mt-4">
                        <button className="btn btn-success w-100" type="submit">Send Reset Link</button>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>

              <div className="mt-4 text-center">
                <p className="mb-0">Wait, I remember my password... <Link to="/login" className="fw-semibold text-primary text-decoration-underline"> Click here </Link> </p>
              </div>

            </Col>
          </Row>
        </Container>
      </div>
    </ParticlesAuth>
  );
};

ForgetPasswordPage.propTypes = {
  history: PropTypes.object,
};

export default withRouter(ForgetPasswordPage);
